import { authApiService } from '@/api/authApiService';
import { ApiResponseType } from '@/types/sharedTypes';
import { UpdateInvitedUserPayloadType, UpdateInvitedUserResponseType } from '@/api/types';

type UpdateRecipientByProxyResponseType = UpdateInvitedUserResponseType & {
  recipient: {
    id: string;
  };
};

export const updateRecipientByProxyApi = (
  wireId: string,
  userId: string,
  data: UpdateInvitedUserPayloadType
): Promise<ApiResponseType<UpdateRecipientByProxyResponseType>> => {
  const uri = `/recipient/wires/${wireId}/recipients/users/${userId}/`;

  return authApiService.PATCH(uri, data);
};
